import React, { useState, useEffect } from "react";
import { Canvas } from "@react-three/fiber";
import "./App.css";
import { FitnessBandModel } from "./Band";
import TextAnimation from "./TextAnimation";

/**
 * Main Application Component
 * Features a sticky 3D canvas with staggered text reveal animations.
 */
const App = () => {
  const scroll = useScrollProgress();

  return (
    <div className="app-container">
      {/* 3D STICKY SECTION */}
      <div className="canvas-container" style={{ zIndex: 2 }}>
        {/* BACKGROUND SLOGAN */}
        <div 
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            zIndex: -1, 
            textAlign: "center",
            width: "100%",
            pointerEvents: "none"
          }}
        >
          <TextAnimation 
            text="we track feelings!" 
            className="animate-text-style"
            staggerDelay={0.04}
            style={{ 
              letterSpacing: "0.0em",
            }} 
          />
        </div>

        <Canvas camera={{ position: [0, 0, 5], fov: 40 }}>
          <ambientLight intensity={0.8} />
          <directionalLight position={[10, 10, 0]} intensity={1} />
          {/* The band component now handles its own entry logic */}
          <FitnessBandModel scroll={scroll} />
        </Canvas>
      </div>

      {/* SCROLLABLE CONTENT SECTIONS */}
      <div className="scroll-sections">
        <section className="scroll-section" style={{ height: "300vh", backgroundColor: "#aaa" }} />

      </div>
    </div>
  );
};

/**
 * Custom Hook: useScrollProgress
 */
function useScrollProgress() {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const onScroll = () => {
      const maxScroll = document.body.scrollHeight - window.innerHeight;
      if (maxScroll <= 0) {
        setProgress(0);
      } else {
        const currentProgress = window.scrollY / maxScroll;
        setProgress(currentProgress);
      }
    };

    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();

    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return progress;
}

export default App;